import { render, staticRenderFns } from "./DrawerButtonColor.vue?vue&type=template&id=31d4e09e&"
import script from "./DrawerButtonColor.vue?vue&type=script&lang=js&"
export * from "./DrawerButtonColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports